/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import ChooseAutopaySource from './ChooseAutopaySource/index'
import CloseAction from './CloseAction/index'
import Loading from './Loading/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PayWithAutopay from './PayWithAutopay/index'
import PayWithInvoice from './PayWithInvoice/index'
import React from 'react'
import SourceInvoice from './SourceInvoice/index'
import SubmitAction from './SubmitAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaIconPaymentPlan from 'DesignSystem/Svgs/TysiaIconPaymentPlan/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content",
  isSubmitting
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsBlue800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.800'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let paymentsEditAutopayIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_edit_autopay',
})
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 width="720px"
 height="534px"
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbc-7-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconPaymentPlan
  viewPath={`${viewPath}/TysiaIconPaymentPlan`}
 height={18}
 width={18}
 fill={dtColorsBlue800}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="medium"
 color={dtColorsNeutral900}
 text="Edit autopay"
/>
</div>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--oy-8-Z1Yf8zk': paymentsEditAutopayIsSubmittingData ? "hidden" : "auto"}}
 className={`views-block ${styles.Vertical}`}
>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pb-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<SourceInvoice
  viewPath={`${viewPath}/SourceInvoice`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h5"
 weight="medium"
 text="How does the payor want to pay?"
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<PayWithAutopay
  viewPath={`${viewPath}/PayWithAutopay`}
/>
<PayWithInvoice
  viewPath={`${viewPath}/PayWithInvoice`}
/>
</div>
</div>
<ChooseAutopaySource
  viewPath={`${viewPath}/ChooseAutopaySource`}
/>
</div>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--btc-9-Z1Yf8zk': dtColorsNeutral200,'--bblr-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal3}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}